<div class="b2a-favsContainer">
  <div class="b2a-favsContainer__inner" *ngIf="favs && favs.length > 0">
    <app-box
      [boxType]="'new'"
      [type]="'add'"
      (onSelect)="openMpDialog()"
      [title]="'EXERCISES.newProgram' | translate"
      [@box]
    >
    </app-box>

    <app-box
      *ngFor="let fav of favs"
      [boxType]="'mp'"
      [type]="'play'"
      [num]="fav.exerciseIds.length"
      [preview]="fav.previewUrl"
      [title]="fav.title"
      (onSelect)="openVideoDialog(fav)"
      (onRemove)="removeBox(fav)"
      (onEdit)="editBox(fav)"
      [@box]
    >
    </app-box>
  </div>

  <div class="b2a-favsContainer__placeholder" *ngIf="!favs || favs.length == 0" [@placeholder]>
    <img src="/assets/images/createUP.png" alt="" />
    <app-introtext *ngIf="!isKids">
      <h1>{{ 'EXERCISES.EDITOR.header' | translate }}</h1>
      <p>{{ 'EXERCISES.EDITOR.subheader' | translate }}</p>
    </app-introtext>
    <app-introtext *ngIf="isKids">
      <h1>Erstelle dir eigene Übungsprogramme</h1>
      <p>
        Wähle 1 bis 3 Übungen aus verschiedenen Themenbereichen aus. Du kannst deine Übungsprogramme auch
        personalisisern.
      </p>
    </app-introtext>
    <button mat-raised-button color="accent" (click)="openMpDialog()">{{ 'EXERCISES.newProgram' | translate }}</button>
  </div>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/favs/favs.component.html